import { COLORS } from '@Commons';

export const skeletonProps = {
  baseColor: COLORS.disabled2,
  highlightColor: COLORS.borderbottom
};
